import React, { useState, forwardRef } from "react";
import "../StyleComponent/ContentICICI.css";
import upiQRImage from "../Assets/BankQR.png";
import posImage from "../Assets/POS.png";
import soundboxImage from "../Assets/Soundbox.png";
import paymentGatewayImage from "../Assets/payment.png";
import PopupForm from "../Components/PopupForm";

const ContentICICI = forwardRef((props, ref) => {
  const [selectedSolutions, setSelectedSolutions] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [currentSolution, setCurrentSolution] = useState(null);

  const solutions = [
    {
      id: "upi_qr",
      name: "UPI QR",
      description: "Instant collections, faster checkouts",
      image: upiQRImage,
    },
    {
      id: "pos",
      name: "POS",
      description: "Accept all payment modes",
      image: posImage,
    },
    {
      id: "soundbox",
      name: "SoundBox",
      description: "Instant payment voice alert",
      image: soundboxImage,
    },
    {
      id: "payment_gateway",
      name: "Payment Gateway and Links",
      description: "Collect payments remotely",
      image: paymentGatewayImage,
    },
  ];

  const handleSolutionSelect = (id) => {
    let updatedSolutions;

    if (selectedSolutions.includes(id)) {
      updatedSolutions = selectedSolutions.filter(
        (solutionId) => solutionId !== id
      );
    } else {
      updatedSolutions = [...selectedSolutions, id];
    }

    setSelectedSolutions(updatedSolutions);
  };

  const handleKnowMoreClick = (solution, e) => {
    e.stopPropagation(); // Prevent the card from being selected
    if (props.onKnowMore) {
      props.onKnowMore(solution); // Call the callback with the selected solution
    }
  };

  const handleProceedClick = () => {
    if (selectedSolutions.length > 0) {
      setCurrentSolution(selectedSolutions[0]);
      setShowPopup(true);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    setCurrentSolution(null);
  };

  return (
    <>
      <div className='container'>
        <div className='payment-solutions1' ref={ref}>
          <h1 className='hh1'>Choose the solution you want</h1>
          <h2 className='hh2'>(You can choose multiple options)</h2>
          <div
            className='solution-grid1'
            style={{
              marginInline: "auto",
            }}
          >
            {solutions.map((solution) => (
              <SolutionCard
                key={solution.id}
                {...solution}
                isSelected={selectedSolutions.includes(solution.id)}
                onSelect={() => handleSolutionSelect(solution.id)}
                onKnowMore={(e) => handleKnowMoreClick(solution, e)}
              />
            ))}
          </div>
          <button className='get-growing-btn' onClick={handleProceedClick}>
            Proceed
          </button>
        </div>
      </div>
      {showPopup && (
        <PopupForm
          solution={currentSolution}
          selectedSolutions={selectedSolutions}
          onClose={closePopup}
          onSolutionSelect={handleSolutionSelect}
        />
      )}
    </>
  );
});

const SolutionCard = ({
  id,
  name,
  description,
  isSelected,
  onSelect,
  image,
  onKnowMore,
}) => {
  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`solution-card ${isSelected ? "selected" : ""}`}
      onClick={onSelect}
    >
      <div className='toggle'>
        <div className={`toggle-slider ${isSelected ? "active" : ""}`}></div>
        {!isSelected && <span className='toggle-text'>Select</span>}
      </div>
      <div class="img-container"><img className='img' src={image} alt={name} /></div>

      <h3
        style={{
          fontWeight: "bolder",
        }}
      >
        {name}
      </h3>
      <p
        className='paragraf'
        style={{
          fontWeight: "400",
        }}
      >
        {description}
      </p>

      <a
        style={{
          top: -20,
        }}
        href='#'
        className='know-more'
        onClick={(event) => {
          event.preventDefault();
          onKnowMore(event);
          scrollToBottom();
        }}
      >
        Know more
      </a>
    </div>
  );
};

export default ContentICICI;
